"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardPaymentStatus = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var ui_1 = require("./ui");
function isValidStatus(value) {
    return (!!value && ['success', 'pending', 'error', 'cancelled'].includes(value));
}
exports.CardPaymentStatus = (0, core_1.withCustomerAndAccountIds)(function (_a) {
    var _b;
    var statusProp = _a.status;
    var Redirect = (0, core_1.useComponents)().Redirect;
    var home = (0, core_1.useLinks)().home;
    var search = window.location.search;
    var status = statusProp || (0, core_1.getValueFromQueryParams)('status', search);
    var txId = (0, core_1.getValueFromQueryParams)('txId', search);
    var amount = (0, core_1.getValueFromQueryParams)('amount', search);
    if (!isValidStatus(status)) {
        return react_1.default.createElement(Redirect, { to: home() });
    }
    return (react_1.default.createElement(ui_tools_1.AnalyticsPage, { name: analytics_subjects_1.CARD_PAYMENT_STATUS, properties: (_b = { status: status }, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
        react_1.default.createElement(ui_1.CardPaymentStatusUI, { status: status, txId: txId, amount: amount })));
});
